module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "pa-3 mb-2"
  }, [_c('dialog-loader', {
    attrs: {
      "d-title": "Terms & Conditions",
      "content-url": "https://www.gungho.com/terms-conditions/#copyright"
    }
  }, [_c('a', {
    staticClass: "mr-4"
  }, [_vm._v("© " + _vm._s(_vm.year) + " Gung-Ho")])]), _vm._v(" "), _c('dialog-loader', {
    attrs: {
      "d-title": "Terms & Conditions",
      "content-url": "https://www.gungho.com/terms-conditions/"
    }
  }, [_c('a', {
    staticClass: "mr-4"
  }, [_vm._v("Terms")])]), _vm._v(" "), _c('dialog-loader', {
    attrs: {
      "d-title": "Privacy Policy",
      "content-url": "https://www.gungho.com/privacy-policy/"
    }
  }, [_c('a', {
    staticClass: "mr-4"
  }, [_vm._v("Privacy")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gungho.com/genie/"
    }
  }, [_vm._v("Powered by GENIE")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71d3a1d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/footer-menu.vue
// module id = 804
// module chunks = 1